
import { Component, Prop, Emit, Provide, ProvideReactive, Vue, Watch } from "vue-property-decorator";
import { v4 as uuid } from "uuid";

@Component({})
export default class RadioGroup extends Vue {
  // TODO: valueに基づいたControlledなコンポーネントにしたいがprovide関係でなぜかうまく行ってないので修正
  @Prop()
  @ProvideReactive("selectedValue")
  value?: string;
  @Prop({ default: false }) sideBySide!: boolean;
  @Provide() formId = uuid();
  @Provide() selectItem = (value: string | undefined) => {
    this.onRadioChange(value);
  };
  @Emit("onChange")
  onRadioChange(value: string | undefined) {}

  get formClasses() {
    return {
      sideBySide: this.sideBySide,
    };
  }

  onWheel(event: WheelEvent) {
    if (event.deltaY === 0) return;
    event.preventDefault();
    (this.$refs.itemsContainer as HTMLElement).scrollLeft += event.deltaY;
  }
}
